export const CDP_GET_TOKEN_DETAILS = 'cdp_getTokenDetails';
export const CDP_GET_MINT_DETAILS = 'cdp_getMintDetails';
export const CDP_MINT_TOKEN = 'cdp_mintToken';
